import { GraphUtils } from '@helpers/graph.helper';
import { Sensor, dataChart } from './sensor';
import { Router } from '@angular/router';

export class WaterConductivitySensor extends Sensor {
  public conductivityChart: any;
  public temperatureChart: any;

  private conductivitySensor: any[];
  private temperatureSensor: any[];

  constructor(router: Router, url: string, alerstActive: boolean) {
    super(router, url, alerstActive);
    this.conductivityChart = null;
    this.temperatureChart = null;

    this.conductivitySensor = [[], [], []];
    this.temperatureSensor = [[], [], []];
  }

  public hasCondSensor(pos: number): boolean {
    return this.conductivitySensor[pos - 1].length > 0;
  }

  public getCondSensor(pos: number): any {
    const realPos: number = this.conductivitySensor[pos - 1].length - 1;
    return this.conductivitySensor[pos - 1][realPos][1] ?? null;
  }

  public hasTemperatureSensor(pos: number): boolean {
    return this.temperatureSensor[pos - 1].length > 0;
  }

  public getTemperatureSensor(pos: number): any {
    const realPos: number = this.temperatureSensor[pos - 1].length - 1;
    return this.temperatureSensor[pos - 1][realPos][1] ?? null;
  }

  public prepareData(): void {
    for (const element of this.data) {
      const date = new Date(element.date);
      this.conductivitySensor[element.position].push([
        GraphUtils.getDateUtc(date),
        element.conductivity,
      ]);
      this.temperatureSensor[element.position].push([
        GraphUtils.getDateUtc(date),
        element.temperature,
      ]);
    }
  }

  public setCharts(): void {
    this.conductivityChart = this.getConfigChar(
      'wcCond',
      this.getChartSeries('ec', this.conductivitySensor),
      this.getRanges('10_conductivity'),
      this.getLimits('10_conductivity')
    );
    this.temperatureChart = this.getConfigChar(
      'wcTemp',
      this.getChartSeries('Temp', this.temperatureSensor),
      this.getRanges('10_temperature'),
      this.getLimits('10_temperature')
    );
  }

  public static getVariables(): any[] {
    return [
      { title: 'Temperatura', value: '10_temperature' },
      { title: 'Conductividad', value: '10_conductivity' }
    ];
  }
}